import React, { useState } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

import Toolbar from "@mui/material/Toolbar";

import Button from "@mui/material/Button";
import CustomDrawer from "../components/CustomDrawer";

import ButtonGroup from "@mui/material/ButtonGroup";
import AddIcon from "@mui/icons-material/Add";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";

import EmployeeAttendanceChart from "../components/EmployeAttendenceCHart";
import { useLocation } from 'react-router-dom';

import axios from "axios";
import EmployeWorkQualityChart from "../components/EmployeWorkQualityChart";
import EmployeTaskChart from "../components/EmployeTaskCHart";
import EmployeeGoalsChart from "../components/EmployeeGoalsChart";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Layout from "../components/layout/Layout";
import RemoveIcon from "@mui/icons-material/Remove";

const EmployeeDashboard = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [newPerformance, setnewPerformance] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();
  const { name } = location.state || {}; 

  const handleDownloadClick = (event) => {
    setAnchorEl(event.currentTarget);
  };



  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <>
      <Layout >
        <div>
        {name && <h1 className="ms-5 ">{name}</h1>}
          <Box
            sx={{
              position: "fixed",
              top: 0,
              right: 6,
              marginTop: isDrawerOpen ? 0 : 6, 

              zIndex: 1300,
            }}
          >
            <ButtonGroup
              sx={{
                marginTop: 3,
                marginLeft: 7,
                justifyItems: "center",
                backgroundColor: "#FD6262",
              }}
              variant="contained"
              aria-label="Basic button group"
            >
              <Button
                sx={{
                  backgroundColor: "#FD6262",
                  display: "flex",
                  justifyItems: "center",
                  alignItems: "center",

                  "&:hover": { backgroundColor: "#FF4D4D" },
                }}
              >
                <RemoveIcon />
              </Button>
              <Button
                sx={{
                  backgroundColor: "#FD6262",
                  "&:hover": { backgroundColor: "#FF4D4D" },
                }}
              >
                <AddIcon />
              </Button>
              <Button
                sx={{
                  backgroundColor: "#FD6262",
                  "&:hover": { backgroundColor: "#FF4D4D" },
                }}
                onClick={handleDownloadClick}
              >
                <ArrowCircleDownIcon />
              </Button>
              <Button
                sx={{
                  backgroundColor: "#FD6262",
                  "&:hover": { backgroundColor: "#FF4D4D" },
                }}
                onClick={handleDrawerToggle}
              >
                <RemoveRedEyeIcon />
              </Button>
            </ButtonGroup>
          </Box>

          <CustomDrawer
            isDrawerOpen={isDrawerOpen}
            handleDrawerToggle={handleDrawerToggle}
          />

          <Box
            component="main"
            sx={{
              flexGrow: 1,
              width: "100%",
              paddingTop: "64px",
              paddingRight: `${isDrawerOpen ? "20%" : "0px"}`,
            }}
          >
            <Toolbar />
            <Box component="section" mt={4}>
              <Container>
                <Grid
                  container
                  spacing={4}
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  <Grid item xs={12} md={6} style={{ display: "flex" }}>
                    <Paper
                      sx={{ padding: 4, backgroundColor: "#e0e0e0", flex: 1 }}
                      elevation={3}
                    >
                      <EmployeeGoalsChart />
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6} style={{ display: "flex" }}>
                    <Paper
                      sx={{ padding: 4, backgroundColor: "#d0d0d0", flex: 1 }}
                      elevation={3}
                    >
                      <EmployeWorkQualityChart />
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6} style={{ display: "flex" }}>
                    <Paper
                      sx={{ padding: 4, backgroundColor: "#c0c0c0", flex: 1 }}
                      elevation={3}
                    >
                      <EmployeTaskChart />
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6} style={{ display: "flex" }}>
                    <Paper
                      sx={{ padding: 4, backgroundColor: "#b0b0b0", flex: 1 }}
                      elevation={3}
                    >
                      <EmployeeAttendanceChart />
                    </Paper>
                  </Grid>
                </Grid>
              </Container>
            </Box>
          </Box>
        </div>
      </Layout>
    </>
  );
};

export default EmployeeDashboard;
